import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { ShellAppBar, ShellBottomNav, ShellLayout, ShellUserMenu, } from '@marinoscar/platform-web/shell/ui';
import { BrandLockup } from '../brand/index.js';
import { withoutPinned } from './navigation.js';
const DEFAULT_BRAND = _jsx(BrandLockup, {});
/**
 * The KVox app shell, one component for every host: the platform's `ShellLayout`
 * with the KVox brand lockup in the app bar, the left rail, the phone bottom bar
 * and the user menu, all drawn from one `navigation`.
 *
 * @remarks
 * Hosts supply only host facts: the navigation (`createKvoxNavigation`), app bar
 * actions, banners and overlays, user menu rows. Everything else, including the
 * five coupled breakpoint gates, is the platform's: THIS FILE READS NO BREAKPOINT
 * and none may be added (`apps/web/src/__tests__/config/breakpointGates.test.ts`
 * scans this package too).
 *
 * The phone bar gets the navigation without its pinned destinations (a pinned
 * destination is a mode, never a peer on the bar; {@link withoutPinned}), so a host
 * never builds a second navigation for it.
 *
 * It makes no request of its own. In a local single-user host mount it under the
 * platform's `LocalIdentityProvider` and a `ShellPreferencesProvider`; in a server
 * host, under the usual `AuthProvider`.
 *
 * Render it as a layout route element, so the matched child renders in its
 * `<Outlet />`.
 *
 * @param props - see {@link KvoxAppShellProps}.
 * @returns the shell.
 *
 * @example
 * ```tsx
 * <Route element={<KvoxAppShell navigation={navigation} userMenuItems={ITEMS} />}>
 *   {renderKvoxRoutes(kvoxNotesRoutes)}
 * </Route>
 * ```
 *
 * @extensionPoint slot
 * @stability experimental
 */
export function KvoxAppShell({ navigation, actions, banners, overlays, userMenuItems, renderUserMenuItems, showThemeToggle = true, brand = DEFAULT_BRAND, children, }) {
    const appBar = (_jsx(ShellAppBar, { navigation: navigation, brand: brand, actions: actions, userMenu: _jsx(ShellUserMenu, { navigation: navigation, ...(renderUserMenuItems ? { items: renderUserMenuItems } : {}), ...(userMenuItems ? { extraItems: userMenuItems } : {}) }) }));
    return (_jsx(ShellLayout, { navigation: navigation, appBar: showThemeToggle ? (appBar) : (_jsx(Box, { sx: { display: 'contents', '& [aria-label="toggle theme"]': { display: 'none' } }, children: appBar })), bottomNav: _jsx(ShellBottomNav, { navigation: withoutPinned(navigation) }), banners: banners, overlays: overlays, children: children }));
}
